import { createFileRoute } from '@tanstack/react-router';
import { McpOAuthFlow } from '@/features/mcp/McpOAuthFlow';
import { requireAuth } from '@/utils/authGuard';

export const Route = createFileRoute('/mcp/oauth/callback')({
  beforeLoad: requireAuth,
  component: McpOAuthFlow,
});
